import { motion } from 'framer-motion'
import React from 'react'
import Lottie, { LottieProps } from 'react-lottie'

/**
 * Componente que se encarga de renderizar los lotties al momento de no tener data.
 * @param {LottieProps['options']['animationData']} animationProps Propiedades de animacion que tendrá el lottie.
 * @param {ReactElement} children Prop de react que se encarga de renderizar lo que se encuentra dentro del componente.
 * @param {LottieProps} lottieProps Estilos de los lotties.
 */
const Empty: React.FC<EmptyProps> = ({
  animationProps,
  children,
  lottieProps,
  isFromLoading = false,
  loop = true
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="p-5 bg-gray-50 dark:bg-gray-900 dark:bg-opacity-30 rounded-lg text-gray-400 flex justify-center flex-col items-center bg-transparent text-center"
      style={{backgroundColor: isFromLoading ? 'transparent' : ''}}
    >
      <Lottie
        {...lottieProps}
        width={animationProps.width}
        height={animationProps.height}
        options={{
          loop,
          autoplay: true,
          animationData: animationProps.animation,
          rendererSettings: { className: 'cursor-default' },
        }}
      />
      {children}
    </motion.div>
  )
}

export default Empty

interface EmptyProps {
  isFromLoading?: boolean
  animationProps: {
    animation: LottieProps['options']['animationData']
    width: number | string
    height: number | string
  }
  lottieProps?: Omit<LottieProps, 'options'>
  loop?: boolean
}
